import { ModalsState } from './types';

// eslint-disable-next-line import/prefer-default-export
export const modalsStateSelector = ({ modals }): ModalsState => modals;
